import makeStyles from '@mui/styles/makeStyles';

export const useSepsisStyles = makeStyles((theme) => ({
    background: {
        backgroundColor: theme.palette.background.paperDarker,
    },
    dialogTitle: {
        textAlign: 'center',
        padding: '10px',
    },
    buttonCancel: {
        background: '#fff',
        width: '100px',
        color: '#000',
        '&:hover': {
            background: '#fff',
        },
    },
    buttonReject: {
        width: '300px',
    },
    buttonSave: {
        backgroundColor: '#a61c00',
        width: '100%',
        color: '#fff',
        height: 'auto !important',
        borderRadius: 6,
        '&:hover': {
            backgroundColor: '#a61c00',
            color: '#fff',
        },
    },
    anywayButtonSave: {
        backgroundColor: '#ffb74d',
        width: '100%',
        color: '#000',
        height: 'auto !important',
        borderRadius: 6,
        '&:hover': {
            backgroundColor: '#ffb74d',
            color: '#000',
        },
    },
    blink: {
        border: '2px solid #fff',
        animation: 'blink 1s',
        animationIterationCount: 'infinite',
        borderRadius: '5px',
        padding: '2px 3px',
        cursor: 'pointer',
        fontSize: '14px',
    },
    category: {
        padding: '5px',
        fontWeight: 'bold',
        marginBottom: '10px',
    },
    section: {
        marginBottom: '15px',
    },
    checkboxLabel: {
        // background: theme.palette.background.paper,
        paddingRight: '5px',
        margin: '2px',
        minWidth: '100%',
    },
    sectionBox: {
        minHeight: 42,
        textAlign: 'left',
        paddingTop: 6,
    },
    sectionBoxAdult: {
        minHeight: 55,
        height: '100%',
        textAlign: 'left',
    },
    sectionSource: {
        textAlign: 'center',
        padding: 6,
        fontWeight: 'bold',
        fontSize: 11,
        color: '#dd7e6b',
    },
    input: {
        width: '100%',
        fontSize: '15px',
        backgroundColor: theme.palette.background.paper,
        height: 42,
    },
    textInput: {
        height: 9,
        fontSize: 14,
    },
    divider: {
        height: '1px',
        background: '#fff',
        marginBottom: '10px',
        marginTop: '10px',
    },
    smallFont: {
        fontSize: 'small',
        margin: '5px',
        '&.red': {
            color: theme.palette.mode === 'light' ? '#e24528' : '#dd7e6b',
        },
    },
    infoBox: {
        background: '#cfe2f3',
        color: 'black',
        fontSize: '12px',
        fontWeight: 'bold',
        textAlign: 'center',
        margin: '10px',
    },
    newObsWarning: {
        color: '#434343',
        fontSize: 'large',
        textAlign: 'center',
        fontWeight: 'bold',
        background: '#f1c232',
        marginBottom: 5,
        padding: 10,
    },
    footer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
}));